import { render } from "./SearchBar.vue?vue&type=template&id=673938c4&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=673938c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673938c4"]])

export default __exports__